import { motion } from 'framer-motion';
import { Box, Search, Bot, Workflow } from 'lucide-react';

const products = [
  {
    icon: Box,
    title: '3D Asset Refinery',
    description: 'Transform messy 3D models into production-ready USD assets. GLB/FBX/OBJ → Clean USD + Web-optimized GLB. 84% compression, MaterialX support.',
    cta: 'Try Upload',
    link: '#viewer'
  },
  {
    icon: Search,
    title: 'AI Search API',
    description: 'Perplexity-powered search with reasoning chains. Natural language queries with cited sources. Perfect for knowledge bases and research tools.',
    cta: 'View Docs',
    link: '#contact'
  },
  {
    icon: Bot,
    title: 'Agent Systems',
    description: 'Custom AI agents that work 24/7. Subordinate agents with specialized skills, persistent memory, and automated workflows.',
    cta: 'Learn More',
    link: '#contact'
  },
  {
    icon: Workflow,
    title: 'Rapid Deployment',
    description: 'Vite + React → Nixpacks → Coolify. Zero-config deployments. Your site live in minutes, not hours. Infrastructure as a service.',
    cta: 'See Pipeline',
    link: '#services'
  }
];

export default function Products() {
  return (
    <section id="products" className="section">
      <motion.h2 
        className="section-title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        Products & <span>Tools</span>
      </motion.h2>
      
      <div className="products-grid">
        {products.map((product, index) => (
          <motion.div
            key={product.title}
            className="product-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.1, duration: 0.5 }}
          >
            <div className="product-icon">
              <product.icon size={28} />
            </div>
            <h3>{product.title}</h3>
            <p>{product.description}</p>
            <a href={product.link} className="btn btn-secondary" style={{ display: 'inline-block' }}>
              {product.cta}
            </a>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
